let time = true;
let countdown = 30;
let countdownAction;
function setupQuerstion(question) {
  countdownAction = setInterval(() => { countdownFunctionInterval(question) }, 1000);
  const form = question.querySelector('form');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    countdown = 30;
    clearInterval(countdownAction);
    nextPage(question);
  });
}

function countdownFunctionInterval(questionElement) {
  const countdownNumberEl = questionElement.querySelector('.question__timer__wrapper strong');
  const popupEl = questionElement.querySelector('.question__timeOut');
  countdown = --countdown <= 0 ? 0 : countdown;
  countdownNumberEl.textContent = countdown;
  if (countdown === 0) {
    clearInterval(countdownAction);
    popupEl.style.display = 'flex';
    questionElement.style.overflow = 'hidden';
    questionElement.classList.add('scenario__item--pass');
  }
  else {
    // countdownFunctionInterval(questionElement)
  }
}